import './content/content.component';
import './sidebar/sidebar.component';
import './site.component';

const main = document.querySelector('main[role="main"].main');
main.append(document.createElement('site-root'));
main.removeChild(document.querySelector('.loader'));